export async function api_createTemplate() {
    const CreateBtns = document.querySelectorAll('.Create_InvitationBtn');
    
    // 모달 내부 요소들
    let createTemplateModal, mobileInvitationOption, weddingPosterOption, closeTemplateModal, cancelTemplateButton;
    
    // 모바일 기기 체크 함수
    function isMobileDevice() {
        return (window.innerWidth <= 768) || 
               (navigator.userAgent.match(/Android/i) || 
                navigator.userAgent.match(/webOS/i) || 
                navigator.userAgent.match(/iPhone/i) || 
                navigator.userAgent.match(/iPad/i) || 
                navigator.userAgent.match(/iPod/i) || 
                navigator.userAgent.match(/BlackBerry/i) || 
                navigator.userAgent.match(/Windows Phone/i));
    }
    
    // DOM이 모두 로드된 후 요소 참조 설정
    document.addEventListener('DOMContentLoaded', () => {
        createTemplateModal = document.getElementById('CreateTemplateModal');
        mobileInvitationOption = document.getElementById('mobileInvitationOption');
        weddingPosterOption = document.getElementById('weddingPosterOption');
        closeTemplateModal = document.getElementById('closeTemplateModal');
        cancelTemplateButton = document.getElementById('cancelTemplateButton');
        
        // 모달 닫기 이벤트 설정
        if (closeTemplateModal) {
            closeTemplateModal.addEventListener('click', closeModal);
        }
        
        if (cancelTemplateButton) {
            cancelTemplateButton.addEventListener('click', closeModal);
        }
        
        // 모바일 청첩장 옵션 클릭 이벤트
        if (mobileInvitationOption) {
            mobileInvitationOption.addEventListener('click', handleMobileInvitationCreate);
        }
        
        // 웨딩 포스터 옵션 클릭 이벤트
        if (weddingPosterOption) {
            weddingPosterOption.addEventListener('click', handleWeddingPosterCreate);
        }
    });
    
    // 모달 닫기 함수
    function closeModal() {
        if (createTemplateModal) {
            createTemplateModal.style.display = 'none';
        }
    }
    
    // 모바일 청첩장 생성 처리 함수
    async function handleMobileInvitationCreate() {
        // 로그인 정보가 있을 경우
        const productID = sessionStorage.getItem('pending_productID') || "DesignArch";
        
        try {
            const response = await fetch('/api_CreateTemplate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    productID: productID
                })
            });
            
            // 리다이렉트 감지 (로그인 페이지로 리다이렉트 되었는지 확인)
            if (response.redirected && response.url.includes('/api_Auth/login')) {
                // 로그인 전에 productID를 세션에 저장
                sessionStorage.setItem('pending_productID', productID);
                sessionStorage.setItem('redirectAfterLogin', 'create_template');
                window.location.href = '/api_Auth/login';
                return;
            }
            
            // 인증 관련 처리
            if (response.status === 401) {
                // 로그인 전에 productID를 세션에 저장
                sessionStorage.setItem('pending_productID', productID);
                sessionStorage.setItem('redirectAfterLogin', 'create_template');
                window.location.href = '/api_Auth/login';
                return;
            }
            
            if (!response.ok) {
                throw new Error('템플릿 생성 요청에 실패했습니다.');
            }
            
            const responseData = await response.json();
            const templateID = responseData.templateID;
            
            // 생성된 템플릿 상세 페이지로 이동
            window.location.href = `/api_CreateTemplate/${templateID}`;
            
            console.log('템플릿 생성 성공, ID:', templateID);
            
        } catch (error) {
            console.error('템플릿 생성 중 오류:', error.message);
        }
    }
    
    // 특정 제품 ID로 모바일 청첩장 생성 처리 함수
    async function handleSpecificTemplateCreate(productID) {
        try {
            const response = await fetch('/api_CreateTemplate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    productID: productID
                })
            });
            
            // 리다이렉트 감지 (로그인 페이지로 리다이렉트 되었는지 확인)
            if (response.redirected && response.url.includes('/api_Auth/login')) {
                // 로그인 전에 productID를 세션에 저장
                sessionStorage.setItem('pending_productID', productID);
                sessionStorage.setItem('redirectAfterLogin', 'create_template');
                window.location.href = '/api_Auth/login';
                return;
            }
            
            // 인증 관련 처리
            if (response.status === 401) {
                // 로그인 전에 productID를 세션에 저장
                sessionStorage.setItem('pending_productID', productID);
                sessionStorage.setItem('redirectAfterLogin', 'create_template');
                window.location.href = '/api_Auth/login';
                return;
            }
            
            if (!response.ok) {
                throw new Error('템플릿 생성 요청에 실패했습니다.');
            }
            
            const responseData = await response.json();
            const templateID = responseData.templateID;
            
            // 생성된 템플릿 상세 페이지로 이동
            window.location.href = `/api_CreateTemplate/${templateID}`;
            
            console.log('템플릿 생성 성공, ID:', templateID);
            
        } catch (error) {
            console.error('템플릿 생성 중 오류:', error.message);
        }
    }
    
    // 웨딩 포스터 생성 처리 함수
    async function handleWeddingPosterCreate() {
        // 모바일 기기에서는 얼럿 표시
        if (isMobileDevice()) {
            alert('웨딩 포스터는 현재 PC 데스크탑 환경에서만 제작 가능합니다. 데스크탑으로 이용해주세요.');
            closeModal();
            return;
        }
        
        try {
            // templateDesign_ID 가져오기 위한 기본값
            const templateDesign_ID = "a_nm";
            
            const response = await fetch('/api_CreateWeddingPoster/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ templateDesign_ID })
            });
            
            // 리다이렉트 감지 (로그인 페이지로 리다이렉트 되었는지 확인)
            if (response.redirected && response.url.includes('/api_Auth/login')) {
                // 로그인 전에 정보를 세션에 저장
                sessionStorage.setItem('pending_productID', templateDesign_ID);
                sessionStorage.setItem('redirectAfterLogin', 'wedding_poster');
                window.location.href = '/api_Auth/login';
                return;
            }
            
            // 인증 관련 처리
            if (response.status === 401) {
                // 로그인 전에 정보를 세션에 저장
                sessionStorage.setItem('pending_productID', templateDesign_ID);
                sessionStorage.setItem('redirectAfterLogin', 'wedding_poster');
                window.location.href = '/api_Auth/login';
                return;
            }
            
            if (!response.ok) {
                throw new Error('웨딩 포스터 생성 요청에 실패했습니다.');
            }
            
            const result = await response.json();
            if (result.success) {
                window.location.href = `/wedding-poster-editor/${result.templateID}`;
            } else {
                console.error('템플릿 생성에 실패했습니다.');
                window.location.href = '/wedding-poster';
            }
        } catch (error) {
            console.error('Error creating template:', error);
            window.location.href = '/wedding-poster';
        }
    }
    
    // CREATE 버튼에 클릭 이벤트 추가
    CreateBtns.forEach(CreateBtn => {
        CreateBtn.addEventListener('click', (event) => {
            // 템플릿 사용하기 버튼인지 확인 (imgGridWrap_create_button ID를 가진 버튼)
            if (CreateBtn.id === 'imgGridWrap_create_button') {
                // 템플릿 사용하기 버튼일 경우 data-value 속성에서 productID 가져오기
                const productID = CreateBtn.getAttribute('data-value');
                if (productID) {
                    // 바로 해당 템플릿으로 생성 처리
                    handleSpecificTemplateCreate(productID);
                }
            } else {
                // 헤더의 CREATE 버튼일 경우 모달 표시
                if (createTemplateModal) {
                    createTemplateModal.style.display = 'flex';
                    createTemplateModal.style.zIndex = '1000000000';
                } else {
                    console.error('CreateTemplateModal을 찾을 수 없습니다.');
                }
            }
        });
    });
}

export default api_createTemplate;
